import axios from 'axios'

const API_URL =
  process.env.REACT_APP_BACKEND_API_URL || 'https://api-stage.4.fun'

export async function updateProfile(
  val: {
    nickname: string
    twitter: string
    telegram: string
    image_url?: string
  },
  access_token: string
): Promise<void> {
  try {
    const res = await axios.post(`${API_URL}/backend/profile`, val, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access_token}`,
        'access-token': access_token
      }
    })
    return res.data
  } catch (error) {
    console.error('Error updating profile:', error)
  }
}

export async function updateProfileImage(
  file: File,
  access_token: string
): Promise<any> {
  try {
    const res = await axios.postForm(
      `${API_URL}/backend/profile/image`,
      { file },
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'access-token': access_token
        }
      }
    )
    return res.data
  } catch (error) {
    console.error('Error updating profile image:', error)
  }
}

export async function getMyInfo(access_token: string): Promise<any> {
  try {
    console.log('access_token', access_token)
    const res = await axios.get(`${API_URL}/backend/profile/me`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        'access-token': access_token
      }
    })
    return res.data
  } catch (error) {
    console.error('Error getting profile info:', error)
  }
}

export async function getProfileInfo(address: string): Promise<void> {
  try {
    const res = await axios.get(`${API_URL}/backend/profile/${address}`)
    return res.data
  } catch (error) {
    console.error('Error getting profile info:', error)
  }
}

export async function getProfileBalance(address: string): Promise<void> {
  try {
    const res = await axios.get(`${API_URL}/backend/profile/${address}/balance`)
    return res.data
  } catch (error) {
    console.error('Error getting profile balance:', error)
  }
}

export async function getProfileCreatedTokens(address: string): Promise<void> {
  try {
    const res = await axios.get(`${API_URL}/backend/profile/${address}/created`)
    return res.data
  } catch (error) {
    console.error('Error getting profile created tokens:', error)
  }
}

export async function getProfileFollowings(address: string): Promise<any> {
  try {
    const res = await axios.get(
      `${API_URL}/backend/profile/${address}/followings`
    )
    return res.data
  } catch (error) {
    console.error('Error getting profile followings:', error)
  }
}

export async function getProfileFollowers(
  address: string,
  page = 1,
  limit = 12
): Promise<any> {
  try {
    const res = await axios.get(
      `${API_URL}/backend/profile/${address}/followers?page=${page}&limit=${limit}`
    )
    return res.data
  } catch (error) {
    console.error('Error getting profile followers:', error)
  }
}

export async function followProfile(
  address: string,
  access_token: string
): Promise<void> {
  try {
    const res = await axios.post(
      `${API_URL}/backend/profile/follow/${address}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'access-token': access_token
        }
      }
    )
    return res.data
  } catch (error) {
    console.error('Error following profile:', error)
  }
}

export async function unfollowProfile(
  address: string,
  access_token: string
): Promise<void> {
  try {
    const res = await axios.post(
      `${API_URL}/backend/profile/unfollow/${address}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'access-token': access_token
        }
      }
    )
    return res.data
  } catch (error) {
    console.error('Error unfollowing profile:', error)
  }
}
